export default {
  namespaced: true,
  state: {
    agentForms: [],
    agentFormItem: null,
  },
  getters: {
    getAgentForms(state) {
      return state.agentForms;
    },
    getAgentFormItem(state) {
      return state.agentFormItem;
    },
  },
  mutations: {
    SET_AGENT_FORMS(state, agentForms) {
      state.agentForms = agentForms;
    },
    SET_AGENT_FORM_ITEM(state, agentFormItem) {
      state.agentFormItem = agentFormItem;
    },
  },
  actions: {
    setAgentForms({ commit }) {
      //todo (valentine): update when  endpoint is ready
      commit('SET_AGENT_FORMS', []);
      return Promise.resolve([]);
    },
    setAgentFormItem({ commit }, agentFormItem) {
      commit('SET_AGENT_FORM_ITEM', agentFormItem);
      return Promise.resolve({});
    },
  },
};